import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const REGISTER_URL = "https://app.nobilenext.com.br/register";

const SLIDER_SETTINGS = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: true,
  adaptiveHeight: false,
  centerMode: false,
  variableWidth: false,
};

const SLIDES = [
  {
     image: "/img/slide1.jpeg",
     title: "Investimento Seguro",
     protectedText: "e personalizado!",
     subtitle: "Ser Nobile Next é ajudar você a realizar o seu sonho.",
   },
   {
     image: "/img/slide2.jpeg",
     title: "Investidor invista com",
     protectedText: "Segurança e Tranquilidade",
     subtitle: "No Nobile Next você encontra tranquilidade, liberdade, investimentos com segurança!",
   },
   {
     image: "/img/slide3.jpeg",
     title: "Emprestimo",
     protectedText: "Seguro",
     subtitle: "No Nobile Next você encontra confiança para investir nos seus sonhos!",
   },
  
];

const openInNewTab = () => {
  window.open(REGISTER_URL, "_blank", "noreferrer");
};

const SlideItem = ({ slide }) => (
  <div className="slide-wrapper">
    <div className="slide-image">
      <img
        src={slide.image}
        alt={slide.title}
        loading="lazy"
        className="slide-img"
      />
      <div className="overlay">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 col-xs-12 intro-text">
              <h1 className="upp">{slide.title}</h1>
              {slide.protectedText && (
                <p className="protected-text">{slide.protectedText}</p>
              )}
              <p className="subtitle m-top m-bottom">{slide.subtitle}</p>
              <button className="btn btn-custom btn-lg" onClick={openInNewTab}>
                Abra sua conta
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const Slidershow = () => {
  // Se tiver só 1 slide → renderiza estático
  if (SLIDES.length === 1) {
    return (
      <div className="slideshow">
        <SlideItem slide={SLIDES[0]} />
      </div>
    );
  }

  // Se tiver mais de 1 slide → usa react-slick
  return (
    <div className="slideshow">
      <Slider {...SLIDER_SETTINGS}>
        {SLIDES.map((slide, index) => (
          <SlideItem key={index} slide={slide} />
        ))}
      </Slider>
    </div>
  );
};
